import { BaseOrganizationsService } from '../../services';

export class OrganizationsSharedService extends BaseOrganizationsService {}
